import * as actionTypes from 'actions';

const initialState = {
  loggedIn: true,
  user: {
    first_name: 'محراب',
    last_name: 'باباپور',
    email: 'demo@devias.io',
    avatar: '/images/avatars/avatar_11.png',
    bio: 'توسعه دهنده',
    role: 'ADMIN' // ['GUEST', 'USER', 'ADMIN']
  }
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SESSION_LOGIN: {
      return {
        ...initialState
      };
    }

    case actionTypes.SESSION_LOGOUT: {
      return {
        ...state,
        loggedIn: false,
        user: {
          role: 'GUEST'
        }
      };
    }
    case actionTypes.PROJECT_CHANGED:
      return initialState

    default: {
      return state;
    }
  }
};

export default sessionReducer;
